<template>
  <cms-modal2
    :title="title"
    :unique="unique"
    @closedModal="$emit('update_visibility', true)"
    size="xl">
    <div>
      <div class="row mb-2">

        <div class="input-group col-12 col-sm-6 col-lg-4 mb-2">
          <label for="crew_search" class="px-2 py-0 m-0 border-0 bg-white font-weight-bold input-group-text input-group-prepend">Search Crew:</label>
          <input id="crew_search" class="form-control form-control-xs" v-model="crewSearchParam.searchValue" @keyup.enter="searchCrew" type="text" placeholder="Enter Name">
          <button type="button" class="btn input-group-append input-group-text" @click="searchCrew">
            <i class="fas fa-search"></i>
          </button>
        </div>

        <div class="input-group col-12 col-sm-3 col-lg-4 mb-2">
          <label class="px-2 py-0 m-0 border-0 input-group-text font-weight-bold bg-white input-group-prepend form-label-xs" for="rank_id">Rank:</label>
          <select id = "rank_id" v-model="crewSearchParam.rank" @change="searchCrew" class="form-control form-control-xs">
            <option :value="0">All Ranks</option>
            <option v-for="rank in rankKeys" :key="rank.id" :value="rank.id">{{ rank.name }}</option>
          </select>
        </div>

        <div class="input-group col-12 col-sm-3 col-lg-4">
          <label class="px-2 py-0 m-0 border-0 input-group-text font-weight-bold bg-white input-group-prepend form-label-xs" for="manning_id">Manning:</label>
          <select id = "manning_id" v-model="manning" @change="searchCrew" class="form-control form-control-xs" disabled>
            <option :value="0">All Mannings</option>
            <option v-for="manning in manningKeys" :key="manning.id" :value="manning.id">{{ manning.alias }}</option>
          </select>
        </div>
      </div>



      <slot name="optional_fields"></slot>

      <table class="table table-sm">
        <thead>
        <tr>
          <th>#</th>
          <th>RANK</th>
          <th>CREW IPN</th>
          <th>FULL NAME</th>
          <th>ACTIVITY CODE</th>
          <th>STATUS</th>
          <th>VESSEL/OFFICE</th>
          <th>NATIONALITY</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="listStatus === 'loading'">
          <td colspan="99">
            <app-loading2
                :loading-status="listStatus === 'loading'"
            ></app-loading2>
          </td>
        </tr>
        <tr v-else v-for="(crew, index) in crewList" :key="crew.id">
          <td>{{ index + pagination.from }}</td>
          <td :title="crew.rankName">{{ crew.rankAlias }}</td>
          <td v-if="crew.ipn">{{ crew.ipn }}</td>
          <td v-else>
                            <span class="bg-lightblue"
                                  title="TEMPORARY CREW CODE"
                            >{{ crew.code }}</span>
          </td>
          <td>{{ crew.fullName }}</td>
          <td :title="crew.activityCodeName"> {{ crew.activityCode }} </td>
          <td>{{ crew.active |status }}</td>
          <td>
            <span v-if="crew.vessel"> {{ crew.vessel }} </span>
            <span v-else>
                                {{ crew.companyOfficeName }}
                                <template v-if="crew.companyOfficeName && crew.assignmentPositionName">/</template>
                                {{ crew.assignmentPositionName }}
                            </span>
          </td>
          <td>{{ crew.nationality }}</td>
          <td>
            <button @click="selectCrew(crew)" class="btn btn-primary" data-dismiss="modal">
              Select
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>



    <nav aria-label="...">
      <ul class="pagination text-smallest">
        <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
          <button class="page-link" @click="setPage(1)">First</button>
        </li>

        <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
          <button class="page-link" @click="setPage(page)">{{ page }}</button>
        </li>

        <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
          <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
        </li>
      </ul>
    </nav>
  </cms-modal2>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {paginationMixin} from "@/mixins/paginationMixin";
import {dataMixin} from "@/mixins/dataMixin";
import {gateMixin} from "@/mixins/gateMixin";
import {vueAppMixin} from "@/mixins/vueAppMixin";
import CmsModal2 from "@/components/elements/CmsModal2.vue";
import AppLoading2 from "@/components/elements/AppLoading2.vue";


export default {
  name: "SearchCrewModal",
  components: {AppLoading2, CmsModal2},
  mixins: [paginationMixin, dataMixin, gateMixin, vueAppMixin],
  props: ['title', 'unique', 'crewList', 'manning', "rank", "visibility"],
  emits: ['return-crew', "update_visibility"],

  data() {
    return {
      listStatus: "empty",
    }
  },

  methods: {
    ...mapActions([
        "getCrewList",
        "getRankKeys",
        "getManningKeys",
    ]),

    ...mapMutations([
      "setCrews"
    ]),

    async searchCrew() {
      this.listStatus = "loading";
      let page = this.pagination.currentPage;
      let params = {
        page: page,
        searchKey: this.crewSearchParam.searchKey,
        searchValue: this.crewSearchParam.searchValue,
        manning: this.$props.manning,
        rank: this.crewSearchParam.rank,
        natl: this.crewSearchParam.natl,
        pooling: this.crewSearchParam.pooling,
        activityCode: this.crewSearchParam.activityCode
      };

      if(this.crewStatus !== '') {
        params['crewStatus'] = this.crewSearchParam.crewStatus;
      }

      await this.getCrewList(params);
      this.listStatus = "filled";
    },

    selectCrew(crew) {
        this.$emit("return-crew", crew);
        this.$emit("update_visibility", false);
    },

    setPage(page) {
      this.pagination.currentPage = page;
      this.searchCrew();
    }
  },

  created() {
    this.getRankKeys();
    this.getManningKeys();
  },

  computed: {
    ...mapGetters([
        "rankKeys",
        "crewSearchParam",
        "manningKeys"
    ]),
  },

  watch: {
    visibility(status) {
      if (status) {
        this.crewSearchParam.rank = this.$props.rank;
        this.crewSearchParam.searchValue = "";
        this.searchCrew();
      }
    }
  }
}
</script>


<style scoped>

</style>